import { render, staticRenderFns } from "./PanelistAlternativesSelector.vue?vue&type=template&id=c84261c6&scoped=true"
import script from "./PanelistAlternativesSelector.vue?vue&type=script&lang=ts"
export * from "./PanelistAlternativesSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84261c6",
  null
  
)

export default component.exports